import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../utils/image';
import { usePlayer } from '../../hooks/player';
import { getPlayerUrl } from '../../utils/routes';

function LeadersRow({ player }) {
  const { topListNumber, stat, matches, logoImageUrl, givenName, surName, id } =
    player;
  const [fullPlayer] = usePlayer(id);
  const teamLogo = logoImageUrl ? getProxyUrl(logoImageUrl, 50, 50) : '';

  const getPlayerName = () => {
    if (!fullPlayer?.displayName) {
      return `${givenName} ${surName}`;
    }

    return fullPlayer?.displayName;
  };

  const getClassName = () => {
    return topListNumber === 1
      ? 'stats-table__row px-lg-2 bg-comp-pink'
      : 'stats-table__row px-lg-2';
  };

  return (
    <div className={getClassName()}>
      <div className="stats-table__number">{topListNumber}</div>
      <a
        href={getPlayerUrl(fullPlayer?.teamAbbrv, getPlayerName())}
        className="stats-table__player text-decoration-none"
      >
        <p className="name-with-team-logo text-color-primary-white m-0">
          <img className="ms-lg-2" src={teamLogo} alt="team" />
          {getPlayerName()}
        </p>
      </a>
      <div className="stats-table__played">{matches}</div>
      <div className="stats-table__value">{stat}</div>
    </div>
  );
}

LeadersRow.propTypes = {
  player: PropTypes.shape({
    topListNumber: PropTypes.number.isRequired,
    stat: PropTypes.number.isRequired,
    matches: PropTypes.number.isRequired,
    logoImageUrl: PropTypes.string.isRequired,
    givenName: PropTypes.string.isRequired,
    surName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default LeadersRow;
